import { Maximize2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Sheet, SheetContent, SheetDescription, SheetTitle } from '@/components/ui/sheet';
import { IncidenteDetalheView } from './IncidenteDetalheView';

/**
 * Detalhe do incidente como painel lateral. Quem monta decide de onde vem o id
 * (`?incidente=` na lista, `/incidentes/:id`, ou estado local quando aberto por
 * cima do detalhe de uma versão) — o link é compartilhável nos dois primeiros casos.
 */
export function IncidenteSheet({
  id,
  aoFechar,
  mostrarAbrirEmPagina = true,
}: {
  id: number | null;
  aoFechar: () => void;
  mostrarAbrirEmPagina?: boolean;
}) {
  return (
    <Sheet open={id !== null} onOpenChange={(aberto) => !aberto && aoFechar()}>
      <SheetContent side="right" className="w-[min(48rem,100vw)] gap-0 p-0 sm:w-[min(48rem,calc(100vw-3rem))]">
        <div className="flex items-center gap-2 border-b border-border px-6 py-3 pr-14">
          <SheetDescription className="flex-1 text-cell">Detalhe do incidente</SheetDescription>
          {id !== null && mostrarAbrirEmPagina ? (
            <Link
              to={`/incidentes/${id}`}
              className="inline-flex items-center gap-1.5 rounded-button px-2 py-1 text-label text-primary transition-colors duration-fast ease-standard hover:bg-primary-wash"
            >
              <Maximize2 className="size-3.5" aria-hidden="true" />
              Abrir em página
            </Link>
          ) : null}
        </div>
        <div className="px-6 py-6">
          {id !== null ? (
            <IncidenteDetalheView
              id={id}
              aoApagar={aoFechar}
              titulo={(texto, className) => <SheetTitle className={`${className} pr-0`}>{texto}</SheetTitle>}
            />
          ) : null}
        </div>
      </SheetContent>
    </Sheet>
  );
}
